var exports = {
  "B": "loadingSkeletonContainer__Np4Bgf",
};

module.exports = exports;
